import clsx from "clsx";
import { FC, HTMLAttributes } from "react";
import { BiPlus } from "react-icons/bi";

type AddDestinationButtonProps = {
  isDisabled?: boolean;
} & HTMLAttributes<HTMLDivElement>;

export const AddDestinationButton: FC<AddDestinationButtonProps> = ({ isDisabled = false, ...props }) => {
  return (
    <div
      {...props}
      className={clsx(
        isDisabled ? "pointer-events-none cursor-default" : "cursor-pointer",
        "flex items-center gap-2 text-sm text-gray"
      )}
    >
      <BiPlus />
      送信先を追加
    </div>
  );
};
